import { Component } from '@angular/core';

@Component({ standalone: false,
  selector: 'app-callback',
  templateUrl: './callback.component.html',
  styleUrls: ['./callback.component.css']
})
export class CallbackComponent {

}
